import { readGitBlobLines } from './read-git-blob-lines.js';
import { readWorktreeFileLines } from './read-worktree-file-lines.js';

export function createHydrateSourceLines(options: {
  repoGitCwd: string;
  pathInRepo: string;
  filePath: string;
}): {
  blobLines: () => Promise<string[] | null>;
  diskLines: () => Promise<string[] | null>;
} {
  let blobCache: string[] | null | undefined;
  let diskCache: string[] | null | undefined;

  const blobLines = async (): Promise<string[] | null> => {
    if (blobCache !== undefined) return blobCache;
    blobCache = await readGitBlobLines(options.repoGitCwd, options.pathInRepo);
    return blobCache;
  };

  const diskLines = async (): Promise<string[] | null> => {
    if (diskCache !== undefined) return diskCache;
    diskCache = await readWorktreeFileLines(options.filePath);
    return diskCache;
  };

  return { blobLines, diskLines };
}
